export const EXTERNAL_ORDER_STATUSES = {
  accepted: 'подтверждён',
  execution: 'исполняется',
  completed: 'заказ завершён',
  canceled: 'заказ отменён',
  unknown: 'состояние не определено',
}
